/* eslint-disable no-unreachable */
/* eslint-disable no-param-reassign */
/* eslint-disable no-alert */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/order */
import React, { useEffect, useState } from "react";
import "firebase/database";
import { makeStyles } from "@material-ui/styles";
import {
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Card,
  CardContent,
  LinearProgress,
  CircularProgress,
  Box,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Snackbar,
  Grid,
  useMediaQuery,
} from "@material-ui/core";
import Select from "react-select";
import YouTube from "react-youtube";
import Alert from "@material-ui/lab/Alert";
import { useHistory } from "react-router-dom";
import { supabase } from "../../supabase";
import { useAuth } from "../../contexts/AuthContext";
import SBFileDownloader from "../shared/SBFileDownloader";
import { useCompany } from "../../contexts/CompanyContext";
import { useSB } from "../../contexts/SupabaseContext";
import isModuleRelevant from "../shared/functions/isModuleRelevant";

import _ from "lodash";
// Material UI Icons
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import AttachmentIcon from "@material-ui/icons/Attachment";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import LanguageIcon from "@material-ui/icons/Language";
import GetAppIcon from "@material-ui/icons/GetApp";
import TimerIcon from "@material-ui/icons/Timer";

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 1200,
    margin: "0 auto",
    padding: theme.spacing(2),
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(4),
  },
  backButton: {
    width: 120,
    marginRight: theme.spacing(2),
    backgroundColor: "#fafafa",
    "&:hover": {
      backgroundColor: "#e0e0e0",
    },
    // border: "2px solid #32a58e",
  },
  moduleTitle: {
    fontWeight: 600,
    fontSize: "1.8rem",
    color: "#333",
    flex: 1,
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: "1.4rem",
    color: "#333",
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(4),
    display: "flex",
    alignItems: "center",
  },
  icon: {
    marginRight: theme.spacing(1.5),
    color: "#32a58e",
  },
  card: {
    borderRadius: 8,
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
    marginBottom: theme.spacing(3),
    overflow: "hidden",
  },
  languageCard: {
    padding: theme.spacing(3),
  },
  selectLabel: {
    fontWeight: 500,
    marginBottom: theme.spacing(1),
    color: "#555",
  },
  videoContainer: {
    marginBottom: theme.spacing(1),
  },
  videoPlayer: {
    width: "100%",
    borderRadius: 8,
    backgroundColor: "#000",
    overflow: "hidden",
  },
  noContent: {
    color: "#666",
    fontStyle: "italic",
    padding: theme.spacing(2, 0),
  },
  attachmentItem: {
    borderRadius: 8,
    marginBottom: theme.spacing(1),
    "&:hover": {
      backgroundColor: "rgba(50, 165, 142, 0.05)",
    },
  },
  downloadLink: {
    color: "#32a58e",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    "& svg": {
      marginLeft: theme.spacing(1),
    },
  },
  questionCard: {
    padding: window.innerWidth < 600 ? theme.spacing(1) : theme.spacing(3),
    marginBottom: theme.spacing(2),
    border: "1px solid #e0e0e0",
    borderRadius: 8,
    borderLeft: "3px solid #32a58e",
  },
  questionText: {
    fontWeight: 500,
    fontSize: "1.1rem",
    marginBottom: theme.spacing(2),
  },
  radioOption: {
    marginBottom: theme.spacing(1),
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(8),
  },
  submitButton: {
    backgroundColor: "#32a58e",
    color: "white",
    padding: theme.spacing(1.5, 4),
    fontSize: "1rem",
    borderRadius: 50,
    "&:hover": {
      backgroundColor: "#288a74",
    },
  },
  dialogTitle: {
    backgroundColor: "#f9f9f9",
    padding: theme.spacing(2, 3),
  },
  dialogContent: {
    padding: theme.spacing(3),
  },
  dialogActions: {
    padding: theme.spacing(2, 3),
    borderTop: "1px solid #eee",
  },
  dialogButton: {
    borderRadius: 20,
    padding: theme.spacing(0.75, 3),
    textTransform: "none",
    fontWeight: 500,
  },
  cancelButton: {
    color: "#666",
  },
  confirmButton: {
    backgroundColor: "#32a58e",
    color: "white",
    "&:hover": {
      backgroundColor: "#288a74",
    },
  },
  resultsContainer: {
    textAlign: "center",
    padding: theme.spacing(2, 0),
  },
  percentage: {
    fontSize: "2.5rem",
    fontWeight: 600,
    color: props => (props.passed ? "#32a58e" : "#f44336"),
    marginBottom: theme.spacing(1),
  },
  threshold: {
    fontSize: "1rem",
    color: "#666",
    marginBottom: theme.spacing(3),
  },
  resultMessage: {
    fontSize: "1.2rem",
    fontWeight: 500,
    color: props => (props.passed ? "#32a58e" : "#f44336"),
    marginBottom: theme.spacing(3),
  },
  progressContainer: {
    margin: theme.spacing(3, 0),
  },
  progress: {
    height: 10,
    borderRadius: 5,
  },
  progressPassed: {
    backgroundColor: "#32a58e",
  },
  progressFailed: {
    backgroundColor: "#f44336",
  },
  loadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    minHeight: "60vh",
  },
  loadingText: {
    marginTop: theme.spacing(2),
    color: "#666",
  },
  errorAlert: {
    borderRadius: 8,
  },
  divider: {
    margin: theme.spacing(4, 0),
  },
  infoAlert: {
    borderRadius: 8,
    backgroundColor: "rgba(50, 165, 142, 0.08)",
    color: "#32a58e",
    marginBottom: theme.spacing(2),
  },
}));

/**
 * The TrainingAttempt component renders a training module in a multi-step process.
 * The user selects a language and then is presented with a video and additional content.
 * The user is then presented with a series of questions and must answer them all correctly
 * to pass the module. The user is shown a summary of their results and can then close the
 * window.
 */
function TrainingAttempt() {
  const history = useHistory();
  const { insertRow } = useSB();
  const { currentUser } = useAuth();
  const { activeSuppliers, productTypes } = useCompany();

  // States
  const [loadingPage, setLoadingPage] = useState(true);
  const [trainingModuleContent, setTrainingModuleContent] = useState([]);
  const [language, setLanguage] = useState("");
  const [languageOptions, setLanguageOptions] = useState([]);
  const [passed, setPassed] = useState(false);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const [percentage, setPercentage] = useState(0);
  const [openResults, setOpenResults] = useState(false);
  const [additionalContent, setAdditionalContent] = useState([]);
  const [moduleData, setModuleData] = useState(undefined);
  const [timeToComplete, setTimeToComplete] = useState(0);
  const [loadingTime, setLoadingTime] = useState(true);

  const isMobile = useMediaQuery("(max-width:600px)");

  // Custom styles based on passed/failed status
  const styleProps = { passed };
  const classes = useStyles(styleProps);

  const id = window.location.pathname.split("/")[2];

  const downloadBucket = "zawadi_university";
  // Function to fetch external content from a specified download bucket and ID, then update the state with the content
  const fetchExternalContent = () =>
    SBFileDownloader(downloadBucket, id).then(arr => {
      setAdditionalContent(arr);
    });

  const {
    refs_max_structure_level_id: userStructureLevel,
    is_leader: isLeader,
  } = currentUser;

  const fetchModule = async moduleId => {
    const { data, error: sbError } = await supabase
      .schema(process.env.REACT_APP_SB_SCHEMA)
      .from("training_master")
      .select(
        "*, training_refs_product_type_index(refs_product_type_id), training_supplier_index(suppliers_master_id)"
      )
      .eq("id", moduleId)
      .eq("training_refs_product_type_index.is_active", true)
      .eq("training_supplier_index.is_active", true);

    if (sbError) {
      console.error(sbError.message);
      throw sbError;
    } else {
      const { training_refs_product_type_index, training_supplier_index } =
        data[0];

      const modProductTypesMap = training_refs_product_type_index.map(
        pt => pt.refs_product_type_id
      );
      const modSuppliersMap = training_supplier_index.map(
        sup => sup.suppliers_master_id
      );

      const fullModule = {
        ...data[0],
        module_suppliers: modSuppliersMap,
        module_product_types: modProductTypesMap,
      };

      const trimmedModule = _.omit(fullModule, [
        "product_types",
        "suppliers",
        "selected_levels",
        "training_refs_product_type_index",
        "training_supplier_index",
      ]);

      setModuleData(trimmedModule);
    }
  };

  useEffect(() => {
    fetchModule(id);
  }, []);

  useEffect(async () => {
    if (moduleData) {
      const {
        is_compulsory,
        module_product_types,
        module_suppliers,
        refs_structure_level_id: moduleStructureLevel,
        training_types,
      } = moduleData;

      const { relevant } = isModuleRelevant(
        module_product_types,
        module_suppliers,
        training_types,
        is_compulsory,
        moduleStructureLevel,
        productTypes,
        activeSuppliers,
        isLeader,
        userStructureLevel
      );

      if (relevant || currentUser.is_admin) {
        fetchExternalContent();
        // Get the languages available for the module's videos
        const uniqueLanguages = new Set();

        // If no videos are available, alert the user and redirect to the training page
        if (!moduleData.videos || moduleData.videos.length === 0) {
          window.alert("No content available for this module");
          window.location.href = "/training";
          return;
        }

        // Add video languages to the uniqueLanguages set
        if (moduleData.videos) {
          moduleData.videos.forEach(entry => {
            if (entry.video_language) {
              uniqueLanguages.add(entry.video_language);
            }
          });
        }

        // Convert the set of languages to an array and map to options format
        const uniqueLanguagesArray = Array.from(uniqueLanguages);

        const languageOptionsArray = uniqueLanguagesArray.map(languageLocal => {
          return { value: languageLocal, label: languageLocal };
        });

        // Set the language options and default language in the state
        setLanguageOptions(languageOptionsArray);
        setLanguage(languageOptionsArray[0].value);

        const questionsArray = [];

        // Shuffle the questions randomly
        const shuffledQuestions = [...moduleData.questions];

        for (let i = shuffledQuestions.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [shuffledQuestions[i], shuffledQuestions[j]] = [
            shuffledQuestions[j],
            shuffledQuestions[i],
          ];
        }

        // Filter questions based on language
        const filteredQuestions = await getQuestionsByLanguage(
          moduleData.marks,
          shuffledQuestions
        );

        // Modify the question bank to include the shuffled and filtered questions
        filteredQuestions.forEach(question => {
          questionsArray.push({
            question: question.question,
            question_language: question.question_language,
            options: generateOptions(
              question.options,
              parseInt(question.max_options)
            ),
          });
        });

        // Update the training module content with the modified questions
        setTrainingModuleContent({
          ...moduleData,
          questions: questionsArray,
        });

        setLoadingPage(false);
      } else {
        setLoadingPage(false);
        setError("You are not registered for this content");
      }
    }
  }, [moduleData]);

  // Function to group questions by language and select a specified number of questions for each language
  const getQuestionsByLanguage = (marks, questions) => {
    return new Promise(resolve => {
      const questionsByLanguage = {};

      // Group questions by language
      questions.forEach(q => {
        if (!questionsByLanguage[q.question_language]) {
          questionsByLanguage[q.question_language] = [];
        }
        questionsByLanguage[q.question_language].push(q);
      });

      // Select questions based on marks for each language
      const selectedQuestions = [];

      Object.keys(questionsByLanguage).forEach(lang => {
        const langQuestions = questionsByLanguage[lang];
        const selectedLangQuestions = langQuestions.slice(0, marks);
        selectedQuestions.push(...selectedLangQuestions);
      });

      resolve(selectedQuestions);
    });
  };

  // Function to generate options for a question, including the correct option and a specified number of additional options
  const generateOptions = (options, maxOptions) => {
    if (options) {
      const correctOption = options.find(option => option.is_correct);

      // Remove the correct option from the original list
      const remainingOptions = options.filter(
        option => option !== correctOption
      );

      // Reorder the remaining options randomly
      const shuffledList = [...remainingOptions];

      for (let i = shuffledList.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffledList[i], shuffledList[j]] = [shuffledList[j], shuffledList[i]];
      }

      // Calculate how many additional options are needed
      const additionalOptionsCount = Math.max(0, maxOptions - 1);

      // Take additional options from the remaining options (if available)
      const additionalOptions = shuffledList.slice(0, additionalOptionsCount);

      // Combine the correct option and additional options to form the final list
      const finalOptions = [correctOption, ...additionalOptions];

      // Shuffle the final list of options
      const shuffledList2 = [...finalOptions];

      for (let i = shuffledList2.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffledList2[i], shuffledList2[j]] = [
          shuffledList2[j],
          shuffledList2[i],
        ];
      }

      return shuffledList2;
    }
    return [];
  };

  // Function to extract the YouTube video ID from a URL
  const getYouTubeId = url => {
    if (!url || typeof url !== "string") return "";

    const regex =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

    const match = url.match(regex);
    return match ? match[1] : "";
  };

  // Function to reset the selected options for all questions in the training module
  const resetQuestions = () => {
    setTrainingModuleContent(prevState => {
      const newTrainingModuleContent = {
        ...prevState,
      };
      newTrainingModuleContent.questions.forEach(question => {
        question.options.forEach(option => {
          option.checked = false;
        });
      });
      return newTrainingModuleContent;
    });
  };

  // Function to submit the user's answers, calculate the percentage score, and save the results to the database
  const submitAnswers = () => {
    setError("");
    setOpen(false);
    setPercentage(0);

    const questionsInLanguage = trainingModuleContent.questions.filter(
      question => question.question_language === language
    );

    const maxMarks = questionsInLanguage.length;

    let marks = 0;
    let answered = 0;

    // Check if all questions have been answered
    questionsInLanguage.forEach(question => {
      question.options.forEach(option => {
        if (option.checked === true) {
          answered += 1;
        }
      });
    });

    if (answered !== maxMarks) {
      setError("You have not answered all the questions.");
      return;
    }

    // Calculate the marks based on correct answers
    questionsInLanguage.forEach(question => {
      question.options.forEach(option => {
        if (option.checked === true && option.is_correct === true) {
          marks += 1;
        }
      });
    });

    // Calculate the percentage score
    const percentageLocal = (marks / maxMarks) * 100;
    setPercentage(percentageLocal);
    setPassed(percentageLocal >= trainingModuleContent.pass_threshold);

    // Save results to Supabase
    insertRow("training_user_attempt_index", {
      percentage: percentageLocal,
      module_id: id,
      users_master_id: currentUser.id,
      marks,
      max_marks: maxMarks,
      module_content_snapshot: trainingModuleContent,
      pass: percentageLocal >= trainingModuleContent.pass_threshold,
    })
      .then(() => {
        setOpenResults(true);
      })
      .catch(errorLocal => {
        console.error("Error saving training attempt: ", errorLocal);
        setError("Error saving your results. Please try again.");
      });
  };

  const handleTimeToComplete = (duration, content) => {
    let questionCount = content.questions?.length;

    questionCount *= 20; // 10 seconds per question

    let totalTime = duration + questionCount;

    setLoadingTime(false);
    if (totalTime <= 0 || typeof totalTime !== "number" || !totalTime) {
      setTimeToComplete(null);
    } else {
      totalTime /= 60;
      totalTime = Math.ceil(totalTime);
      setTimeToComplete(totalTime);
    }
  };

  const truncateFileName = (fileName, maxLength = 20) => {
    if (!isMobile) {
      return fileName;
    }
    if (!fileName || fileName.length <= maxLength) return fileName;

    // Split the file name into name and extension (if any)
    const lastDotIndex = fileName.lastIndexOf(".");
    let name = fileName;
    let ext = "";
    if (lastDotIndex !== -1 && lastDotIndex !== 0) {
      name = fileName.slice(0, lastDotIndex);
      ext = fileName.slice(lastDotIndex); // Includes the dot
    }

    // Calculate how much to keep from start and end
    const keepLength = Math.floor((maxLength - 3) / 2); // 3 for "..."
    const start = name.slice(0, keepLength);
    const end = name.slice(-keepLength);

    return `${start}...${end}${ext}`;
  };

  // Handle going back to previous page
  const handleGoBack = () => {
    history.goBack();
  };

  // Loading state
  if (loadingPage) {
    return (
      <div className={classes.loadingContainer}>
        <CircularProgress size={60} style={{ color: "#32a58e" }} />
        <Typography className={classes.loadingText}>
          Loading module content...
        </Typography>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      {/* Header with back button and title */}
      <div className={classes.header}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          direction={{ xs: "column", sm: "row" }}
        >
          <Grid item xs={12} sm="auto">
            <Button
              className={classes.backButton}
              variant="contained"
              disableElevation
              startIcon={<ArrowBackIcon />}
              onClick={handleGoBack}
              fullWidth={{ xs: true, sm: false }}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={12} sm>
            <Typography className={classes.moduleTitle}>
              {decodeURI(trainingModuleContent.module_name)}
            </Typography>
          </Grid>
          <Grid item xs={12} sm="auto">
            {!loadingTime && timeToComplete && (
              <Box display="flex" alignItems="center">
                <TimerIcon style={{ marginRight: 8, color: "#666" }} />
                <Typography variant="body2" color="textSecondary">
                  {timeToComplete} min
                </Typography>
              </Box>
            )}
          </Grid>
        </Grid>
        {/* Removed the below for now because we don't have the time */}
      </div>

      {/* Language selection */}
      <Typography className={classes.sectionTitle}>
        <LanguageIcon className={classes.icon} />
        Select Language
      </Typography>
      <Card className={classes.card}>
        <CardContent className={classes.languageCard}>
          <Typography className={classes.selectLabel}>
            Choose your preferred language for this module:
          </Typography>
          <Select
            menuPortalTarget={document.body}
            styles={{
              menuPortal: base => ({
                ...base,
                zIndex: 9999,
              }),
              control: base => ({
                ...base,
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #32a58e",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected
                  ? "#32a58e"
                  : state.isFocused
                  ? "rgba(50, 165, 142, 0.1)"
                  : null,
                "&:hover": {
                  backgroundColor: "rgba(50, 165, 142, 0.1)",
                },
              }),
            }}
            options={languageOptions}
            value={{ value: language, label: language }}
            onChange={e => {
              setLanguage(e.value);
              resetQuestions();
            }}
            placeholder="Select Language"
          />
        </CardContent>
      </Card>

      {/* Videos Section */}
      <Typography className={classes.sectionTitle}>
        <PlayArrowIcon className={classes.icon} />
        Training Videos
      </Typography>

      {trainingModuleContent.videos?.length > 0 &&
        trainingModuleContent.videos
          .filter(entry => entry.video_language === language)
          .map((video, index) => (
            <Card className={classes.card} key={`video-${index}`}>
              <CardContent>
                <Box className={classes.videoContainer}>
                  {video.link && getYouTubeId(video.link) ? (
                    <div className={classes.videoPlayer}>
                      <YouTube
                        onReady={e => {
                          handleTimeToComplete(
                            e.target.getDuration(),
                            trainingModuleContent
                          );
                        }}
                        videoId={getYouTubeId(video.link)}
                        opts={{
                          height: isMobile ? "250" : "450",
                          width: "100%",
                          playerVars: {
                            autoplay: 0,
                          },
                        }}
                      />
                    </div>
                  ) : (
                    <Typography className={classes.noContent}>
                      No video available. Please refer to the additional content
                      below.
                    </Typography>
                  )}
                </Box>
              </CardContent>
            </Card>
          ))}

      {/* Additional Content Section */}
      <Typography className={classes.sectionTitle}>
        <AttachmentIcon className={classes.icon} />
        Additional Content
      </Typography>

      <Card className={classes.card}>
        <CardContent>
          {additionalContent.length === 0 ? (
            <Typography className={classes.noContent}>
              There is no additional content available for this module.
            </Typography>
          ) : (
            <List>
              {additionalContent.map((file, index) => (
                <Paper
                  elevation={0}
                  className={classes.attachmentItem}
                  key={`file-${index}`}
                >
                  <ListItem disableGutters={isMobile}>
                    <ListItemIcon>
                      <AttachmentIcon style={{ color: "#32a58e" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={truncateFileName(file.fileName)}
                      secondary={
                        <a
                          style={{ marginTop: 8 }}
                          href={file.downloadUrl}
                          className={classes.downloadLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download <GetAppIcon fontSize="small" />
                        </a>
                      }
                    />
                  </ListItem>
                </Paper>
              ))}
            </List>
          )}
        </CardContent>
      </Card>

      {/* Questions Section */}
      <Typography className={classes.sectionTitle}>
        <HelpOutlineIcon className={classes.icon} />
        Assessment Questions
      </Typography>

      {/* Information alert */}
      <Alert
        severity="info"
        icon={<CheckCircleIcon fontSize="inherit" />}
        className={classes.infoAlert}
      >
        Answer all questions correctly to pass the module. You need to achieve a
        score of {trainingModuleContent.pass_threshold}% or higher.
      </Alert>

      {trainingModuleContent.questions?.length > 0 ? (
        trainingModuleContent.questions
          .filter(entry => entry.question_language === language)
          .map((question, qIndex) => (
            <Card className={classes.questionCard} key={`question-${qIndex}`}>
              <CardContent>
                <Typography className={classes.questionText}>
                  {qIndex + 1}. {question.question}
                </Typography>
                <FormControl component="fieldset" fullWidth>
                  <RadioGroup
                    value={
                      question.options.find(opt => opt.checked)?.text || ""
                    }
                    onChange={e => {
                      const indexOnOptions =
                        trainingModuleContent.questions.indexOf(question);

                      setTrainingModuleContent(prevState => {
                        const newTrainingModuleContent = {
                          ...prevState,
                        };
                        newTrainingModuleContent.questions[
                          indexOnOptions
                        ].options.forEach(option1 => {
                          if (option1.text === e.target.value) {
                            option1.checked = true;
                          } else {
                            option1.checked = false;
                          }
                        });
                        return newTrainingModuleContent;
                      });
                    }}
                  >
                    {question.options.map((answerOption, aIndex) => (
                      <FormControlLabel
                        key={`answer-${qIndex}-${aIndex}`}
                        value={answerOption.text}
                        control={<Radio color="primary" />}
                        label={answerOption.text}
                        className={classes.radioOption}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </CardContent>
            </Card>
          ))
      ) : (
        <Typography className={classes.noContent}>
          No questions available for this module in the selected language.
        </Typography>
      )}

      {/* Submit button */}
      <div className={classes.buttonContainer}>
        <Button
          variant="contained"
          className={classes.submitButton}
          onClick={() => setOpen(true)}
          disableElevation
        >
          Submit Answers
        </Button>
      </div>

      {/* Confirmation Dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          style: { borderRadius: "12px" },
        }}
      >
        <DialogTitle className={classes.dialogTitle}>
          <Typography variant="h6">Confirm Submission</Typography>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Typography>
            Are you sure you want to submit your answers? You won't be able to
            make changes after submission.
          </Typography>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            className={`${classes.dialogButton} ${classes.cancelButton}`}
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
          <Button
            className={`${classes.dialogButton} ${classes.confirmButton}`}
            onClick={submitAnswers}
            variant="contained"
            disableElevation
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* Results Dialog */}
      <Dialog
        open={openResults}
        onClose={() => handleGoBack()}
        PaperProps={{
          style: { borderRadius: "12px" },
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle className={classes.dialogTitle}>
          <Typography variant="h6">Your Results</Typography>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <div className={classes.resultsContainer}>
            <Typography className={classes.percentage}>
              {parseFloat(percentage).toFixed(0)}%
            </Typography>
            <Typography className={classes.threshold}>
              Required: {trainingModuleContent.pass_threshold}%
            </Typography>

            <Box className={classes.progressContainer}>
              <LinearProgress
                variant="determinate"
                value={Math.min(percentage, 100)}
                className={`${classes.progress} ${
                  passed ? classes.progressPassed : classes.progressFailed
                }`}
              />
            </Box>

            <Typography className={classes.resultMessage}>
              {passed
                ? "Congratulations! You have passed this module."
                : "You did not pass this module. Please try again."}
            </Typography>
          </div>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            className={`${classes.dialogButton} ${classes.confirmButton}`}
            onClick={() => {
              handleGoBack();
              setOpenResults(false);
            }}
            variant="contained"
            disableElevation
          >
            {passed ? "Complete" : "Try Again"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Error Snackbar */}
      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={() => setError("")}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setError("")}
          severity="error"
          className={classes.errorAlert}
        >
          {error}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default TrainingAttempt;
